import * as actions_archive from 'actions/archive-actions';
import * as actions_settings from 'actions/settings-actions';
import React, { useEffect } from 'react';
import firebase from 'firebase/compat/app';
import { Ibox, ModalAlert, Table } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import { toProperCase } from 'components/common/toolbox';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const firestore = firebase.firestore();

export default function ArchiveSearch(props) {

    const dispatch = useDispatch();
    const params = useParams();

    const assetTypesRaw = useSelector((store) => store.settings.settings_asset_types);
    const assetClassificationsRaw = useSelector((store) => store.settings.settings_asset_classification);

    var assetTypes = assetTypesRaw.filter((o) => o.deleted);
    assetTypes = assetTypes.map((o) => ({ ...o, value: toProperCase(o.value) }));

    var assetClassifications = assetClassificationsRaw?.filter((o) => o.deleted && !assetTypes.find((at) => at.id == o.assetType));
    assetClassifications = assetClassifications?.map((o) => ({ ...o, value: toProperCase(o.name) }));


    useEffect(() => {
    }, []);

    const restoreItem = async (type, name, item) => {
        ModalAlert({
            title: 'Are you sure?',
            text: "This " + name + " will be restored.",
            icon: 'warning',
            show_cancel: true,
            confirm_color: '#8FBC8B',
            confirm_text: 'Yes, restore it!',
            callback_success: () => {
                // if (type == 'employee') dispatch(actions_archive.restoreProfile(props.match.params.handle, item.id, 'EMPLOYEE', item, () => {
                //     props.history.replace('/' + props.match.params.handle + '/customers');
                // }));
                if (type == 'assetType') dispatch(actions_settings.saveAssetType(params.handle, { deleted: false }, item.id, null, () => {
                    props.history.replace('/' + props.match.params.handle + '/assets/' + item.id);
                }));
                if (type == 'assetClassification') dispatch(actions_settings.saveCategory(params.handle, { deleted: false }, item.id, 'classification', () => {
                    props.history.replace('/' + props.match.params.handle + '/assets/' + item.assetType);
                }));
            }
        });
    };
    const deleteItem = (type, name, item,) => {
        var text;
        switch (type) {
            case 'assetType':
                text = "This Asset Type will be PERMANENTLY DELETED along with all associated ASSET CLASSIFICATIONS, ASSETS, and PARTS CATEGORIES!";
                break;
            case 'assetClassification':
                text = "This Asset Classification will be PERMANENTLY DELETED along with all associated ASSETS!";
                break;
            default:
                text = "This " + name + " will be PERMANENTLY DELETED!";
                break;
        }

        ModalAlert({
            title: 'Are you sure?',
            text: text,
            icon: 'error',
            input: 'text',
            label: 'To confirm, type "PERMANENTLY DELETE"',
            validator: (value) => {
                if (value != 'PERMANENTLY DELETE') return 'Phrase Not Correct';
            },
            show_cancel: true,
            confirm_color: '#ED5565',
            confirm_text: 'Yes, PERMANENTLY DELETE!',
            callback_success: () => {
                if (type == 'assetType') dispatch(actions_settings.deleteAssetType(props.match.params.handle, item.id, () => {

                }));
                if (type == 'assetClassification') dispatch(actions_settings.deleteAssetClassification(props.match.params.handle, item.id, () => {

                }));
            }
        });
    };


    return (

        <Ibox className="mt-3" title={'Archived Items'} no_fade={true}>

            {!!assetTypes?.length &&
                <>
                    <h4>Asset Types</h4>
                    <Table
                        data={assetTypes}
                        show_limit={false}
                        show_search={true}
                        highlight_search={true}
                        columns={[
                            { name: 'Unit #', field: 'id', width: 5 },
                            { name: 'Name', field: 'value', width: 15 },
                            { name: 'Restore', field: '', type: 'button', button: { name: 'Restore Asset Type', className: 'btn-primary btn-xs', callback: restoreItem.bind(this, 'assetType', 'Asset Type',) }, width: 5 },
                            { name: '', field: '', type: 'button', button: { name: <i className="far fa-trash-alt"></i>, className: 'btn-default btn-xs', callback: deleteItem.bind(this, 'assetType', 'Asset Type') }, width: 1 }
                        ]}
                    />
                </>
            }
            {!!assetClassifications?.length &&
                <>
                    <h4>Asset Classifications</h4>
                    <Table
                        data={assetClassifications}
                        show_limit={false}
                        show_search={true}
                        highlight_search={true}
                        columns={[
                            { name: 'Unit #', field: 'id', width: 5 },
                            { name: 'Name', field: 'value', width: 15 },
                            { name: 'Restore', field: '', type: 'button', button: { name: 'Restore Asset Classification', className: 'btn-primary btn-xs', callback: restoreItem.bind(this, 'assetClassification', 'Asset Classification',) }, width: 5 },
                            { name: '', field: '', type: 'button', button: { name: <i className="far fa-trash-alt"></i>, className: 'btn-default btn-xs', callback: deleteItem.bind(this, 'assetClassification', 'Asset Classification') }, width: 1 }
                        ]}
                    />
                </>
            }
            {
                !assetClassifications?.length &&
                !assetTypes?.length &&
                <h2>There are no Archived Items at this time</h2>
            }

        </Ibox>
    );
}
